import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './main.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Great Plains Technical Services, LLC';
}
